import { Stack, TextField } from "@mui/material";
import { useEffect } from "react";

import { FormCertification } from "./FormCertification";
import { useForm } from "../../../hooks/useForm";

export const FetchCertificationAddress = ({ addresWork, setProducts, setIds, data, setRents }) => {
    const dataFilter = data.filter((e) => e.addressWork === addresWork);
    const [formValues, handleInputChange] = useForm({
        certificationDate: ''
    });
    const { certificationDate } = formValues;

    useEffect(() => {
        if (dataFilter?.length > 0) {
            setIds({
                'workId': dataFilter[0].id,
                'idClient': dataFilter[0].client.id,
                'certificationDate': certificationDate,
                'estimateId': dataFilter[0].estimateId
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [certificationDate])

    return (
        <Stack width='100%' alignItems='center' mt='0.5rem' >
            <Stack width='90%' flexDirection='row' justifyContent='space-around' alignItems='flex-end'>
                <label >Fecha de certificación:</label >
                <TextField
                    sx={{ width: '200px', height: '30px' }}
                    type="date"
                    variant="standard"
                    name='certificationDate'
                    value={certificationDate ? certificationDate : ''}
                    onChange={handleInputChange}
                    required
                />
            </Stack>

            <FormCertification setRents={setRents} setProducts={setProducts} data={dataFilter} />
        </Stack >
    )
}